module.exports = __webpack_public_path__ + "img/noPayShow.34dbdd96.png";